import React from 'react';
import { Check } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { cn } from 'shared/lib/utils';

interface FormCheckboxProps {
  label: React.ReactNode;
  checked: boolean;
  onChange: (next: boolean) => void;
  error?: string;
  id?: string;
}

const FormCheckbox: React.FC<FormCheckboxProps> = ({ label, checked, onChange, error, id }) => {
  const { t } = useTranslation();
  const inputId = id || 'form-checkbox';
  const errorMessage = error ? t(`validation.${error}`, { defaultValue: error }) : undefined;

  return (
    <div className="flex flex-col gap-1.5" data-error={error ? 'true' : undefined}>
      <label
        htmlFor={inputId}
        className="flex items-start gap-3 cursor-pointer group select-none"
      >
        <button
          type="button"
          id={inputId}
          role="checkbox"
          aria-checked={checked}
          aria-invalid={error ? true : undefined}
          onClick={() => onChange(!checked)}
          className={cn(
            'mt-0.5 w-5 h-5 rounded-md border flex items-center justify-center transition-all flex-shrink-0',
            checked
              ? 'bg-gray-900 border-gray-900 text-white'
              : 'bg-white border-gray-300 group-hover:border-gray-400',
          )}
        >
          {checked && <Check size={14} strokeWidth={3} />}
        </button>
        <span className="text-base text-gray-700 leading-relaxed">{label}</span>
      </label>
      {errorMessage && (
        <span className="text-xs font-medium text-red-600 ms-8">{errorMessage}</span>
      )}
    </div>
  );
};

export default FormCheckbox;
